"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.extractEschrefFromLocation = exports.isValideEschref = void 0;

var _params = require("hub-http/helpers/params");

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var ESHREF_KEY = 'SETTINGS_NAV::cached-eschref';

var getPortalId = function getPortalId(pathname) {
  return _hubspot.default.parsePortalIdFromString(pathname, _hubspot.default.pathRegex);
};

var isValideEschref = function isValideEschref(eschref, pathname, portalId) {
  return Boolean(eschref) && eschref.indexOf('/') === 0 && eschref.indexOf('//') !== 0 && getPortalId(pathname) === portalId;
};

exports.isValideEschref = isValideEschref;

var extractEschrefFromLocation = function extractEschrefFromLocation() {
  var portalId = _hubspot.default.get();

  var _window$location = window.location,
      search = _window$location.search,
      pathname = _window$location.pathname;

  var _parse = (0, _params.parse)(String(search).substr(1)),
      eschref = _parse.eschref;

  return isValideEschref(eschref, pathname, portalId) ? eschref : null;
};

exports.extractEschrefFromLocation = extractEschrefFromLocation;
var ReturnLinkHelper = {
  hydrate: function hydrate() {
    var eschref = extractEschrefFromLocation();

    if (eschref) {
      window.sessionStorage.setItem(ESHREF_KEY, extractEschrefFromLocation());
    }
  },
  get: function get() {
    var eschref = extractEschrefFromLocation();
    var cachedEschref = window.sessionStorage.getItem(ESHREF_KEY);

    if (eschref) {
      return eschref;
    } else if (cachedEschref) {
      return cachedEschref;
    }

    return null;
  },
  clear: function clear() {
    window.sessionStorage.removeItem(ESHREF_KEY);
  }
};
var _default = ReturnLinkHelper;
exports.default = _default;